import { render, staticRenderFns } from "./costAccountTemplate.vue?vue&type=template&id=058e19d5&scoped=true&"
import script from "./costAccountTemplate.vue?vue&type=script&lang=js&"
export * from "./costAccountTemplate.vue?vue&type=script&lang=js&"
import style0 from "./costAccountTemplate.vue?vue&type=style&index=0&id=058e19d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e19d5",
  null
  
)

export default component.exports